module.exports = "<!--<div [class.spinner-hidden]=\"!show\" class=\"tmb-spinner\">-->\r\n<div [class.spinner-hidden]=\"!show\" class=\"tmb-spinner\">\r\n  <div class=\"spinner-overlay\">\r\n    <div>\r\n      <md-spinner mode=\"indeterminate\" strokeWidth=\"5\" width=\"50\" class=\"spinner-icon\"></md-spinner>\r\n      <!--<md-progress-bar mode=\"indeterminate\" *ngIf=\"show\"></md-progress-bar>-->\r\n    </div>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/TMB/sr-git-v1/TMB.UI/src/app/components/spinner/spinner.component.html
// module id = ../../../../../src/app/components/spinner/spinner.component.html
// module chunks = main